import {
  AddressFormData,
  ApplicantDetailsAddressType,
  ApplicationApplicantDetailsRead,
} from "@lending/types";

function emptyAddress(): ApplicantDetailsAddressType {
  return {
    street_address: "",
    street_address_2: "",
    city: "",
    region_code: "",
    postal_code: "",
    country_code: "",
  };
}

const ADDRESS_COMPARISON_FIELDS = [
  "street_address",
  "street_address_2",
  "city",
  "region_code",
  "postal_code",
] as const;

function addressesMatch(a: ApplicantDetailsAddressType, b: ApplicantDetailsAddressType): boolean {
  return ADDRESS_COMPARISON_FIELDS.every((field) => (a[field] ?? "") === (b[field] ?? ""));
}

function createDefaultValues(applicant: ApplicationApplicantDetailsRead): AddressFormData {
  const residential_address = {
    street_address: applicant.residential_address?.street_address ?? "",
    street_address_2: applicant.residential_address?.street_address_2 ?? "",
    city: applicant.residential_address?.city ?? "",
    region_code: applicant.residential_address?.region_code ?? "",
    postal_code: applicant.residential_address?.postal_code ?? "",
  };
  const mailing_address = {
    street_address: applicant.mailing_address?.street_address ?? "",
    street_address_2: applicant.mailing_address?.street_address_2 ?? "",
    city: applicant.mailing_address?.city ?? "",
    region_code: applicant.mailing_address?.region_code ?? "",
    postal_code: applicant.mailing_address?.postal_code ?? "",
  };

  return {
    residential_address,
    mailing_address,
    // When "same as mailing" is selected we persist a copy of the residential
    // address into mailing_address (never null), so a populated mailing address
    // that equals residential must still render the checkbox as checked.
    hasSameMailingAddress:
      !applicant.mailing_address || addressesMatch(residential_address, mailing_address),
  };
}

function buildMailingAddress(
  formData: AddressFormData,
  existingMailingAddress: ApplicantDetailsAddressType | null | undefined,
  askMailingAddress: boolean
): ApplicantDetailsAddressType | null {
  if (!askMailingAddress) {
    return existingMailingAddress ?? null;
  }

  if (formData.hasSameMailingAddress) {
    return {
      ...formData.residential_address,
      country_code: "US",
    };
  }

  return {
    ...formData.mailing_address,
    country_code: "US",
  };
}

export { buildMailingAddress, createDefaultValues, emptyAddress };
